import React from 'react';

export default function BreakOverlay({ show, secondsLeft, onEndBreak }) {
  if (!show) return null;

  const maxSeconds = 3600; // 1 hour
  const pct  = Math.min(100, Math.max(0, (secondsLeft / maxSeconds) * 100));
  const deg  = (pct / 100) * 360;

  const overlay = {
    position: 'fixed', inset: 0, zIndex: 99999,
    background: 'rgba(0,0,0,0.85)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    backdropFilter: 'blur(8px)',
    animation: 'fadeIn 0.2s ease',
  };

  const card = {
    background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '20px',
    padding: '40px 48px',
    maxWidth: '440px',
    width: '90%',
    boxShadow: '0 25px 60px rgba(0,0,0,0.6)',
    textAlign: 'center',
    color: '#f1f5f9',
  };

  const ring = {
    width: 120, height: 120,
    borderRadius: '50%',
    background: `conic-gradient(
      ${secondsLeft < 300 ? '#ef4444' : secondsLeft < 900 ? '#f59e0b' : '#3b82f6'} ${deg}deg,
      rgba(255,255,255,0.08) ${deg}deg
    )`,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    margin: '0 auto 24px',
    position: 'relative',
  };

  const ringInner = {
    width: 90, height: 90, borderRadius: '50%',
    background: '#0f172a',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 28, fontWeight: 700,
    color: secondsLeft < 300 ? '#ef4444' : secondsLeft < 900 ? '#f59e0b' : '#3b82f6',
  };

  const btnPrimary = {
    background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
    border: 'none', borderRadius: 10,
    color: '#fff', fontWeight: 600, fontSize: 16,
    padding: '14px 32px', cursor: 'pointer',
    transition: 'opacity 0.2s',
    marginTop: 20,
    width: '100%',
  };

  const m = Math.floor(secondsLeft / 60);
  const s = secondsLeft % 60;
  const timeStr = `${m}:${s < 10 ? '0' : ''}${s}`;

  return (
    <div style={overlay}>
      <div style={card}>
        <div style={ring}>
          <div style={ringInner}>{timeStr}</div>
        </div>
        <h3 style={{ margin: '0 0 10px 0', fontSize: 22 }}>You are on Break</h3>
        <p style={{ margin: '0 0 20px 0', color: '#94a3b8', fontSize: 15, lineHeight: 1.5 }}>
          You have a maximum of 1 hour break time. You will be automatically logged out when the timer ends.
        </p>
        <button style={btnPrimary} onClick={onEndBreak}>
          End Break & Return
        </button>
      </div>
    </div>
  );
}
